import { callable } from '.';
import { GetTokenResponse } from '../../../functions/src/callable/twitch/getToken.f';

export const getTwitchToken = callable<unknown, GetTokenResponse>('getToken');
